import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/img/renyuan.png'


const _hoisted_1 = { class: "articlelist" }
const _hoisted_2 = { class: "flex-n fac fjb articlelist-tab" }
const _hoisted_3 = { class: "info-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "left flex-1" }
const _hoisted_6 = { class: "title line-2" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = ["src"]

import TabContent from "@/components/TabContent/TabContent.vue";
import newsApi from "@/utils/Api/News";
import {ref,onMounted,watch} from "vue";
import {useRouter} from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'articlelist',
  setup(__props) {


const chooseTab=ref('28161467316671127');
// [{label:'行业动态',value:'28113144514257932'},
// {label:'殡葬新闻',value:'28161365535340865'},
// {label:'政策公示',value:'28161467316671127'},
// {label:'协会公告',value:'28168195359550340'}],

const search=ref('');
const menuList=[{
  label:'政策公示',
  value:'28161467316671127'
},{
  label:'行业动态',
  value:'28113144514257932'
}]
onMounted(()=>{
  document.title = '文章列表';
})
const refreshing = ref(false);
const list: any = ref([]);
const pageNo = ref(0);
const refresh = ref(false);
const loading = ref(false);
const finished = ref(false);
const contentTitle=ref('');

watch(()=>chooseTab.value,(newval)=>{
  console.log(newval)
  onRefresh();
})

const onRefresh = () => {
  pageNo.value = 0;
  list.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  onLoad();
};
const onLoad=()=>{

  pageNo.value++;
  newsApi.list(pageNo.value,{
    "categoryId": chooseTab.value,
    // "categoryId":0,
    contentTitle:contentTitle.value
  }).then(res=>{
    console.log(res)
    list.value = list.value.concat(res.data.data || []);
    if (list.value.length >= res.data.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value = false;
    refresh.value = false;
  })
}
const router=useRouter();

const gotoPage=(path:string)=>{
  router.push(path);
}

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      class: "banner",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabContent, {
        modelValue: chooseTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chooseTab).value = $event)),
        list: menuList
      }, null, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("input", {
        class: "search",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contentTitle).value = $event)),
        placeholder: "文章标题",
        onKeydown: _withKeys(onLoad, ["enter"])
      }, null, 544), [
        [_vModelText, contentTitle.value]
      ])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "info-item flex-n fac",
                  onClick: ($event: any) => (gotoPage('/articledetail?id='+item.id)),
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.contentTitle), 1),
                    _createElementVNode("div", _hoisted_7, "发布日期：" + _toDisplayString(item.contentTime), 1)
                  ]),
                  _createElementVNode("img", {
                    class: "right",
                    src: item.contentCover
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_4))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})